import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { CalendarIconSvg, MoonIconSvg, ShipIconSvg } from "../../assets/svg";
import { splitDate } from "../../utils/splitDate";
import dayjs from "dayjs";

const EnquiryTableRow = ({ item }: any) => {
  const navigate = useNavigate();

  const handleTripType = (tripType: string) => {
    return tripType?.includes('one') ? 'One Way Trip' : 'Round Trip';
  }

  return (
    <>
      <div className="min-h-[171px] my-3 border rounded bg-light">
        <Row className="bg-[#F9FFF2] border-bottom rounded-top min-h-[34px] m-0 justify-content-between align-items-center " style={{ fontSize: "16px", fontWeight: "700" }}>
          <Col>
            <p className="px-2 m-0 text-warning">{item?.number}</p>
          </Col>
          <Col className="d-flex justify-content-end align-items-center">
            <p className="px-2 m-0 text-[#17A300]">STATUS : {item?.status?.toUpperCase()}</p>
          </Col>
        </Row>
        <Row className="justify-content-between m-0 mt-4 text-[#7A7A7A]" style={{ fontSize: "17px", fontWeight: "500" }}>
          <Col className="d-flex align-items-center">
            <CalendarIconSvg height={19} width={19} fill="#7a7a7a" />
            {!!item?.enquiryPref?.startDate ? <p className="mx-1 my-auto">{dayjs(splitDate(item?.enquiryPref?.startDate)).format("DD MMM YYYY")} - {dayjs(splitDate(item?.enquiryPref?.endDate)).format("DD MMM YYYY")}</p> : <p className="mx-1 my-auto">No Date Range Selected</p>}
          </Col>
          <Col className="d-flex align-items-center">
            <p className="mx-1 my-auto">Departure: {item?.enquiryPref?.departure?.name || "NA"}</p>
          </Col>
          <Col className="d-flex align-items-center">
            <p className="mx-1 my-auto">Destination: {item?.enquiryPref?.destination?.name || "NA"}</p>
          </Col>
          <Col className="d-flex align-items-center">
            <p className="mx-1 my-auto">Trip Type: {!!item?.enquiryPref?.tripType ? handleTripType(item?.enquiryPref?.tripType) : 'NA'}</p>
          </Col>
        </Row>
        <Row className="justify-content-between m-0 mt-4 text-[#7A7A7A]" style={{ fontSize: "17px", fontWeight: "500" }}>
          <Col xs={3} className="flex items-center">
            <ShipIconSvg fill="#7a7a7a" height={20} width={18} />
            <span className="mx-1 my-auto">Cruise: {item?.enquiryPref?.shipName || 'NA'}</span>
          </Col>
          <Col className="flex gap-2 items-center">
          <MoonIconSvg fill="#7a7a7a" height={18} width={18}/>
          <span>Nights:</span>
          {!!item?.enquiryPref?.nightCount?.length ? item?.enquiryPref?.nightCount?.map((night: string) => (
              <div className="w-[30px] h-[30px] bg-[#D0566E] flex items-center justify-center rounded">
                <span className="text-[#fff]" key={night}>
                  {night}
                </span>
              </div>
            )): <p className="mx-1 my-auto">NA</p>}
          </Col> 
        </Row>
        <Row className="text-[#7A7A7A] mx-0 mt-4 justify-content-between" style={{ fontSize: "14px", lineHeight: "18.23px" }}>
          <Col xs={3}>
            <p className="m-0" style={{ fontWeight: "400" }}>Full Name</p>
            <p className="m-0 text-capitalize" style={{ fontWeight: "700" }}>{item?.firstName} {item?.lastName}</p>
          </Col>
          <Col xs={3}>
            <p className="m-0" style={{ fontWeight: "400" }}>Phone Number</p>
            <p className="m-0 text-capitalize" style={{ fontWeight: "700" }}>{item?.phoneNumber}</p>
          </Col>
          <Col xs={3} className="-ml-2">
            <p className="m-0" style={{ fontWeight: "400" }}>Email</p>
            <p className="m-0" style={{ fontWeight: "700" }}>{item?.email}</p>
          </Col>
          <Col className="d-flex align-items-center justify-content-end mx-2 py-2">
            <button className="border p-1 rounded bg-[#EEEEEE] text-nowrap my-auto text-[#3A3A3A]" style={{ fontSize: "14px", fontWeight: "400" }} onClick={() => { navigate(`/add-leads/2/${item?.userId}`); }}>
              View Details
            </button>
          </Col>
          <Col>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default EnquiryTableRow;